export const API_ROUTES = {
  auth: {
    login: "/auth/login",
    logout: "/auth/logout",
    refreshToken: "/auth/refresh",
    forgotPassword: {
      init: "/auth/forgot-password",
      generateCode: "/auth/forgot-password/generate-code",
      checkCode: "/auth/forgot-password/check-code",
      finish: "/auth/forgot-password/finish",
    },
    otpSeed: {
      requestNew: "/auth/otp-seed/request-new",
      generateCode: "/auth/otp-seed/generate-code",
      finish: "/auth/otp-seed/finish",
    },
  },
}; 